import ApiService from "@/modules/api/api.service";
import ObjectBuilderInterface from "@/modules/api/object-builder.interface";

import ProductionSnapshot from "./production-snapshot.model";

export default class ProductionSnapshotRepository {
  private readonly fResourceName = "production_snapshot_stats";

  constructor(
    private api: ApiService,
    private objectBuilder: ObjectBuilderInterface<ProductionSnapshot>
  ) {}

  public async fetchProductionSnapshots(): Promise<ProductionSnapshot[]> {
    const response = await this.api.get(this.fResourceName);

    return (response.data as any[]).map((item) =>
      this.objectBuilder.buildFromJSON(item)
    );
  }
}
